var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOtaUpdatesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-OTA"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OTA",
    clipPath: "url(#clip-OTA)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(16576.301 22551.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wifi_black_24dp",
    transform: "translate(-16563.531 -22524.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M0,0H24.457V24.457H0ZM0,0H24.457V24.457H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1,9.59l2.075,2.26a12.459,12.459,0,0,1,18.677,0l2.075-2.26A15.238,15.238,0,0,0,1,9.59Zm8.3,9.04,3.112,3.39,3.112-3.39a4.148,4.148,0,0,0-6.225,0ZM5.15,14.11l2.075,2.26a6.924,6.924,0,0,1,10.376,0l2.075-2.26a9.7,9.7,0,0,0-14.527,0Z",
    transform: "translate(-0.185 -0.822)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "flight_black_24dp",
    transform: "translate(-16544.68 -22560.688) rotate(62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M0,0H32.018V32.018H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M26.683,19.451V16.676L15.447,9.738V2.106a2.106,2.106,0,1,0-4.212,0V9.738L0,16.676v2.775l11.235-3.469v7.631L8.426,25.695v2.082l4.915-1.387,4.915,1.387V25.695l-2.809-2.082V15.982Z",
    transform: "translate(2.135 2.109)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtaUpdatesIcon);
export default __webpack_public_path__ + "static/media/OTAUpdatesIcon.bbc6e13ae1cc871a4ceac3314fdaad23.svg";
export { ForwardRef as ReactComponent };